"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forEach = void 0;

/**
 * Call `fn` over each element of an array
 *
 * @param  {Function}   fn      Function
 * @param  {Array}      source  Source array
 *
 * @return {undefined}
 *
 * @tag Array
 * @signature (fn: Function) => (source: Array): undefined
 */
var forEach = function forEach(fn) {
  return function (source) {
    for (var i = 0, length = source.length; i < length; i++) {
      fn.call(null, source[i], i, source);
    }
  };
};

exports.forEach = forEach;